export const isTastingMenuPackage = (orderPackage) => (
  orderPackage?.package?.type === "TASTING_MENU"
  || orderPackage?.packageType === "TASTING_MENU"
);

export const getOrderPackageItems = (orderPackage) => {
  if (Array.isArray(orderPackage?.packageItems)) return orderPackage.packageItems;
  if (Array.isArray(orderPackage?.items) && orderPackage.items.length > 0) {
    return orderPackage.items;
  }
  return Array.isArray(orderPackage?.package?.items) ? orderPackage.package.items : [];
};

const normalizeCourseIndex = (value) => Math.max(1, Math.trunc(Number(value || 1) || 1));

export const getTastingMenuCourses = (orderPackage) => {
  if (!isTastingMenuPackage(orderPackage)) return [];

  const menuQuantity = Math.max(1, Number(orderPackage?.quantity || 1));
  const courses = new Map();

  getOrderPackageItems(orderPackage).forEach((item) => {
    const courseIndex = normalizeCourseIndex(item?.courseIndex);
    const courseName = String(item?.courseName || "").trim();
    if (!courses.has(courseIndex)) {
      courses.set(courseIndex, { courseIndex, courseName, items: [] });
    } else if (!courses.get(courseIndex).courseName && courseName) {
      courses.get(courseIndex).courseName = courseName;
    }

    courses.get(courseIndex).items.push({
      id: item?.id,
      name: item?.productName || item?.product?.name || "-",
      variantName: item?.variantName || item?.variant?.name || "",
      quantity: Number(item?.quantity || 0) * menuQuantity,
    });
  });

  return [...courses.values()].sort((a, b) => a.courseIndex - b.courseIndex);
};

export const getFixedPriceMenuCourses = (orderFixedPriceMenu) => {
  const menuQuantity = Math.max(1, Number(orderFixedPriceMenu?.quantity || 1));
  const courses = new Map();

  (Array.isArray(orderFixedPriceMenu?.selections) ? orderFixedPriceMenu.selections : [])
    .forEach((selection) => {
      const courseIndex = normalizeCourseIndex(selection?.courseIndex);
      const courseName = String(selection?.groupNameSnapshot || "").trim();
      if (!courses.has(courseIndex)) {
        courses.set(courseIndex, { courseIndex, courseName, items: [] });
      } else if (!courses.get(courseIndex).courseName && courseName) {
        courses.get(courseIndex).courseName = courseName;
      }

      courses.get(courseIndex).items.push({
        id: selection?.id,
        name: selection?.productNameSnapshot || selection?.product?.name || "-",
        quantity: Number(selection?.quantity || 1) * menuQuantity,
        extraPrice: Number(selection?.extraPriceSnapshot || 0),
      });
    });

  return [...courses.values()].sort((a, b) => a.courseIndex - b.courseIndex);
};

export const getOrderMenuSearchText = (order) => {
  const tastingText = (order?.orderPackages || [])
    .flatMap((orderPackage) => [
      orderPackage?.package?.name,
      ...getTastingMenuCourses(orderPackage).flatMap((course) => [
        course.courseName,
        ...course.items.flatMap((item) => [item.name, item.variantName]),
      ]),
    ]);

  const fixedPriceText = (order?.orderFixedPriceMenus || [])
    .flatMap((menu) => [
      menu?.menuNameSnapshot,
      ...getFixedPriceMenuCourses(menu).flatMap((course) => [
        course.courseName,
        ...course.items.map((item) => item.name),
      ]),
    ]);

  return [...tastingText, ...fixedPriceText]
    .filter(Boolean)
    .join(" ")
    .toLowerCase();
};
